import React from 'react';
import { Component } from '@poa/core';
import { HOST_TO_URL } from '../../../store/auth/auth.constants';
import { observable } from '@poa/state';
import { getMenuIcon } from '../../icons/menu';
import LinksUserModal from '../../links-modal/links-user-modal';
import Spinner from 'react-spinkit';


class TrialLinkList extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    env; // injected by Poa
    t; // injected by Poa

    constructor(props) {
        super(props);
        this.state = {
            shareTexts: {},
            spanTexts: {},
        };
      }

    localState = observable({
        isLinkUserModalOpened: false,
        linkId: null,
        links: [],
        isLoading: false
    });

    async componentDidMount() {
        this.localState.isLoading = true;
        try {

            const data = await this.env.http
                .get(`account_trial_links/${this.store.accounts.originalModel.id2}`)
                .then(response => response.data);

            this.localState.links = data.links;
            this.localState.isLoading = false;
        } catch (e) {
            console.log(e);
            this.env.alert(
                'Ошибка',
                `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
            );
            this.localState.isLoading = false;
        }
    }

    onLinkUserModalOpen = (linkId) => {
        this.localState.linkId = linkId;
        this.localState.isLinkUserModalOpened = true;
    };

    onLinkUserModalClose = () => {
        this.localState.isLinkUserModalOpened = false;
        this.localState.linkId = null;
    };

    buildLinkBody = (links) => {
        if (!links)
            return null;

        const body = links.map(link => {
            let watchButton = (
                <button
                    className='links-page_watch_button'
                    onClick={() => window.open(`${HOST_TO_URL['of']}${link.share_link}`, '_blank')}
                >
                    {getMenuIcon('proxy')}
                </button>
            );

            let shareButton = (
                <button
                    className='links-page_share_button'
                    onClick={() => {
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(`${HOST_TO_URL['of']}${link.share_link}`);
                        } else {
                            let textarea = document.createElement('textarea');
                            textarea.textContent = `${HOST_TO_URL['of']}${link.share_link}`;
                            document.body.appendChild(textarea);
                            textarea.select();
                            document.execCommand('copy');
                            document.body.removeChild(textarea);
                        }

                        this.setState(prevState => ({
                            shareTexts: { ...prevState.shareTexts, [link.id]: this.t('links:copied') }
                        }));
                    
                        setTimeout(() => {
                            this.setState(prevState => ({
                                shareTexts: { ...prevState.shareTexts, [link.id]: null }
                            }));
                        }, 3000);
                    }}
                >
                    {this.state.shareTexts[link.id] || this.t('links:share')}
                </button>
            );

            const handleCopyLink = (link_url) => {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(link_url);
                } else {
                    let textarea = document.createElement('textarea');
                    textarea.textContent = link_url;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                }

                this.setState(prevState => ({
                    spanTexts: {
                        ...prevState.spanTexts,
                        [link.id]: this.t('links:copied')
                    }
                }));

                setTimeout(() => {
                    this.setState(prevState => ({
                        spanTexts: {
                            ...prevState.spanTexts,
                            [link.id]: null
                        }
                    }));
                }, 3000);
            }

            return (
                <tr key={link.id}>
                    <td style={{ flex: 1 }}>{link.name}<br />
                        <div className='link-copy'>
                            <span
                                onClick={() => handleCopyLink(link.url)}
                                style={{ color: (!this.state.spanTexts[link.id] || this.state.spanTexts[link.id] === null) ? 'blue' : 'green' }}>
                                {this.state.spanTexts[link.id] || this.t('links:copyLink')}
                            </span>
                        </div>
                        {link.created_at}
                    </td>
                    <td style={{ flex: 1, alignItems: 'center', paddingLeft: '20px' }}>{link.claims}</td>
                    <td style={{ flex: 1, alignItems: 'center', color: (link.revenue > 0) ? "green" : "black" }}>
                        $ {link.revenue} {(link.revenue_from > 0) ?
                            <div className='link-copy' onClick={() => this.onLinkUserModalOpen(link.id)}>
                                <span>from {link.revenue_from} fans</span>
                            </div> : null}
                    </td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{watchButton}</td>
                    <td style={{ flex: 1, alignItems: 'center' }}>{shareButton}</td>
                </tr>
            );
        }
        );
        return (body)
    }


    render() {

        return (
            <div className='general_info__content'>
                {
                    this.localState.isLoading ? (
                        <div
                            className='spinner-loading'
                            style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
                        >
                            <Spinner name='folding-cube' fadeIn='none' />
                        </div>

                    ) :
                    (
                <>
                    <div className='shift-row'>
                        <div className='links-page-body'>
                            <div className='links-page_popup_content'>
                                <table className='table' style={{ tableLayout: 'fixed' }}>
                                    <thead className='links-page-thead' >
                                        <tr>
                                            <th style={{ flex: 1 }}>{this.t('links:trialLink')}</th>
                                            <th style={{ flex: 1 }}>{this.t('links:Claims')}</th>
                                            <th style={{ flex: 1 }}>{this.t('links:Revenue')}</th>
                                            <th style={{ flex: 1 }}>{this.t('links:Watch')}</th>
                                            <th style={{ flex: 1 }}>{this.t('links:Share')}</th>
                                        </tr>
                                    </thead>
                                    <tbody className='links-page-tbody'>
                                        {this.buildLinkBody(this.localState.links)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <LinksUserModal
                        isOpen={this.localState.isLinkUserModalOpened}
                        onRequestClose={this.onLinkUserModalClose}
                        selectedTrialLinkId={this.localState.linkId}
                        linkType='trial_link'
                    />
                </>
                    )
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['account-trial-links'] })(TrialLinkList);